export function filenameFromContentDisposition(
  disposition: string | undefined,
  fallback: string
): string {
  const match = (disposition || "").match(/filename="([^"]+)"/);
  return match?.[1] || fallback;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function exportDownloadErrorMessage(
  error: any,
  fallback: string
): Promise<string> {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const parsed = JSON.parse(text);
      return (
        parsed?.response?.message ||
        parsed?.detail ||
        parsed?.message ||
        fallback
      );
    } catch {
      return fallback;
    }
  }
  if (data?.response?.message) {
    return data.response.message;
  }
  if (typeof data?.detail === "string") {
    return data.detail;
  }
  if (typeof data?.message === "string") {
    return data.message;
  }
  try {
    const parsed = JSON.parse(error?.message || "{}");
    if (parsed?.message) {
      return parsed.message;
    }
  } catch {
    // ignore parse errors
  }
  return error?.message || fallback;
}
